import React from 'react'

import Link from 'components/Link'
import Logo from 'components/Logo'
import TagWithHover from 'components/TagWithHover'
import { useEventContext } from 'context/EventContext'

import classes from './CardHeading.module.scss'

/** @type {import("./types").default} */
const CardHeading = ({ integration }) => {
  const { addEvent } = useEventContext()

  return (
    <>
      <div className={classes.card}>
        <div className={classes.logoContainer}>
          <Link
            href={integration.cta_urls.detail}
            {...addEvent({
              name: 'engagement_product_click',
              engagementComponent: 'product_integrations',
              engagementDestination: 'go-to_product_details',
              engagementDetails: 'logo_integrations',
            })}
          >
            <Logo className={classes.logo} src={`${integration.logo_url}`} alt={`${integration.name} logo`} size={56} />
          </Link>
        </div>
        <div className={classes.info}>
          <Link
            variant="heading-xs"
            href={integration.cta_urls.detail}
            className={classes.listingName}
            {...addEvent({
              name: 'engagement_product_click',
              engagementComponent: 'product_integrations',
              engagementDestination: 'go-to_product_details',
              engagementDetails: 'text-link_product-name-integrations',
            })}
          >
            <span className={classes.productName}>{integration.name} </span>
          </Link>
          {!!integration.avg_importance_rating && (
            <TagWithHover
              size="small"
              customVariant={{
                color: 'teal',
                label: `${integration.avg_importance_rating}`,
                tooltipText: `Reviewers considered this integration as "${integration.avg_importance_rating}"`,
                event: {
                  engagementDestination: 'show_avg-importance-rating-definition',
                  engagementDetails: 'hover_avg-importance-rating',
                },
              }}
            />
          )}
        </div>
      </div>
    </>
  )
}

export default CardHeading
